import { render, staticRenderFns } from "./CalculateSalaryProcessLevyBes.vue?vue&type=template&id=7b940551&"
import script from "./CalculateSalaryProcessLevyBes.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessLevyBes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports